export default __webpack_public_path__ + "static/media/perfil.c3a4cfec.png";